"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var modal_dialog_service_1 = require("@nw/ui-core-shared/services/modal-dialog.service");
var core_2 = require("@ngx-translate/core");
var DealerblockBestOfferCounteredComments = (function () {
    function DealerblockBestOfferCounteredComments(modalDialogService, translateService) {
        this.modalDialogService = modalDialogService;
        this.translateService = translateService;
    }
    DealerblockBestOfferCounteredComments.prototype.showSellerNotes = function () {
        this.modalDialogService.hideModal();
        var sellerNote = {
            title: this.translateService.instant('dealerBlockLayout.sellerNotes'),
            message: this.boCounteredComments,
            showOK: true,
            okContent: this.translateService.instant('dealerBlockLayout.ok')
        };
        this.modalDialogService.showModal(sellerNote);
    };
    DealerblockBestOfferCounteredComments.prototype.ngOnInit = function () {
    };
    return DealerblockBestOfferCounteredComments;
}());
DealerblockBestOfferCounteredComments.decorators = [
    { type: core_1.Component, args: [{
                selector: 'nw-dealerblock-best-offer-countered-comments',
                template: "<span *ngIf=\"boCounteredComments\">\n    <a href=\"javascript:void(0)\" data-a8n=\"db-best-offer-countered-comments\" (click)=\"showSellerNotes()\">\n    {{'dealerBlockLayout.sellerNotes' | translate }}\n    </a>\n</span>"
            },] },
];
/** @nocollapse */
DealerblockBestOfferCounteredComments.ctorParameters = function () { return [
    { type: modal_dialog_service_1.ModalDialogService, },
    { type: core_2.TranslateService, },
]; };
DealerblockBestOfferCounteredComments.propDecorators = {
    'boCounteredComments': [{ type: core_1.Input },],
    'allowBestOffer': [{ type: core_1.Input },],
};
exports.DealerblockBestOfferCounteredComments = DealerblockBestOfferCounteredComments;
//# sourceMappingURL=dealerblock-best-offer-countered-comments.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nw/dealerblock-bid-ui/components/dealerblock-best-offer-countered-comments/dealerblock-best-offer-countered-comments.js
// module id = hWX8
// module chunks = 0